import { render, staticRenderFns } from "./reemplazo-resumen.vue?vue&type=template&id=16d6562e&"
import script from "./reemplazo-resumen.vue?vue&type=script&lang=ts&"
export * from "./reemplazo-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports